import { MENU_HEIGHT } from 'src/components/css'

/** Mobile's top bar is shorter than the desktop nav. */
const MOBILE_HEADER_HEIGHT = 48

/** The editor's layer on a page — cloned from EditPlayerModalContent. */
const PAGE_Z_INDEX = 15

export interface RosterPlayerOverlayBounds {
  zIndex: number
  top: number
  left: number
}

interface RosterPlayerOverlayLayout {
  /** The z-index of the overlay the editor is opened FROM; absent on a page. */
  hostZIndex?: number
  isMobile: boolean
  /** The app sidebar's current width (0 on mobile). */
  sidebarWidth: number
}

/**
 * Where the Edit Player overlay sits.
 *
 * On a page it fills the content area only — below the nav, right of the sidebar —
 * so the app's chrome stays in view, on the page's own layer.
 *
 * SN-8449 — opened from inside another overlay (the Team Budget sheet in the admin
 * Registration Details modal) that page layer is UNDER the host, and the editor
 * opened invisibly behind it. Over a host it goes one layer up and covers the whole
 * viewport: the nav and sidebar are already under the host's mask, and leaving
 * their strips uncovered would show the host modal around the editor.
 */
export const rosterPlayerOverlayBounds = ({
  hostZIndex,
  isMobile,
  sidebarWidth,
}: RosterPlayerOverlayLayout): RosterPlayerOverlayBounds =>
  hostZIndex === undefined
    ? {
        zIndex: PAGE_Z_INDEX,
        top: isMobile ? MOBILE_HEADER_HEIGHT : MENU_HEIGHT,
        left: sidebarWidth,
      }
    : { zIndex: hostZIndex + 1, top: 0, left: 0 }
